export default __webpack_public_path__ + "static/media/mainImage.bf25b4fa.jpeg";